console.log("gothassos/application.js Loaded");

//* Stimulus Application
import { application } from "controllers/application";
window.Stimulus = application;

//* lazysizes
import lazysizes from "lazysizes";
import "lazysizes/plugins/blur-up/ls.blur-up";
lazysizes.cfg.blurupMode = "always";
window.lazysizes = lazysizes;

//* Bootstrap
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

//* Rails functionality
import Rails from "@rails/ujs";
import * as Lexxy from "@37signals/lexxy";
import { highlightCode } from "@37signals/lexxy";
import "@rails/actiontext";
import "@hotwired/turbo-rails";
document.addEventListener("turbo:load", () => highlightCode());
document.addEventListener("turbo:morph", () => highlightCode());

//* Turbo snapshots the page as-is when navigating away, so an open Bootstrap
//* modal would come back as a ghost on back/forward restores. Strip the open
//* state (instantly, no transition) before the page is cached.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll(".modal.show").forEach((modal) => {
    modal.classList.remove("show");
    modal.style.display = "";
    modal.setAttribute("aria-hidden", "true");
    modal.removeAttribute("aria-modal");
    modal.removeAttribute("role");
  });
  document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
});
window.Rails = Rails; //* Make accessible for Electron and Mobile adapters

require("@rails/activestorage").start();

//* I18n for JS
import { i18n } from "../config/i18n";
window.i18n = i18n;

//* Stimulus Controllers
import BootstrapModal from "../view_components/modal/bootstrap/index.js";
application.register("modal--bootstrap", BootstrapModal);

import modal from "./controllers/events/modal/index.js";
application.register("modal", modal);

import filter from "./controllers/events/filter/index.js";
application.register("filter", filter);

import announcements from "./controllers/events/announcements/index.js";
application.register("announcements", announcements);

import events_channel from "./controllers/events/events_channel/index.js";
application.register("events-channel", events_channel);

import infiniteScroll from "./controllers/events/infinite_scroll/index.js";
application.register("infinite-scroll", infiniteScroll);

import scrollToTop from "./controllers/events/scroll_to_top/index.js";
application.register("scroll-to-top", scrollToTop);

import datesCalendar from "./controllers/events/dates_calendar/index.js";
application.register("events--dates-calendar", datesCalendar);

import headroom from "../view_components/headroom/index.js";
application.register("headroom", headroom);

import colorMode from "./controllers/color_mode/index.js";
application.register("color-mode", colorMode);

import backgroundVideo from "./controllers/background_video/index.js";
application.register("background-video", backgroundVideo);

import backgroundVideoToggle from "./controllers/background_video_toggle/index.js";
application.register("background-video-toggle", backgroundVideoToggle);

import offcanvas from "../view_components/offcanvas/index.js";
application.register("offcanvas", offcanvas);

import imageRetry from "./controllers/events/image_retry_controller.js";
application.register("image-retry", imageRetry);

import dealsViewToggle from "./controllers/deals/view_toggle/index.js";
application.register("deals--view-toggle", dealsViewToggle);

import dealsPriceToggle from "./controllers/deals/price_toggle/index.js";
application.register("deals--price-toggle", dealsPriceToggle);

import dealsRowLink from "./controllers/deals/row_link/index.js";
application.register("deals--row-link", dealsRowLink);

import membersViewToggle from "./controllers/members/view_toggle/index.js";
application.register("members--view-toggle", membersViewToggle);

import membersMatchDetails from "./controllers/members/match_details/index.js";
application.register("members--match-details", membersMatchDetails);

import placesViewToggle from "./controllers/places/view_toggle/index.js";
application.register("places--view-toggle", placesViewToggle);

import map from "../view_components/map/index.js";
application.register("map", map);

import gallery_public from "../view_components/public/gallery/index.js";
application.register("public--gallery", gallery_public);

import geolocation_public from "../view_components/public/geolocation/index";
application.register("public--geolocation", geolocation_public);


import Tabs from "../controllers/custom_tabs.js";
application.register("tabs", Tabs);

import clock from "../view_components/clock/index.js";
application.register("clock", clock);

import image_preview from "../view_components/image_preview/index.js";
application.register("image-preview", image_preview);

import popover from "../view_components/popover/index.js";
application.register("popover", popover);

import noscript_cleanup from "../view_components/noscript_cleanup/index.js";
application.register("noscript-cleanup", noscript_cleanup);

import visit from "../view_components/visit/index.js";
application.register("visit", visit);

import title_changer from "../view_components/title_changer/index.js";
application.register("title-changer", title_changer);

import ScrollTo from "@stimulus-components/scroll-to";
application.register("scroll-to", ScrollTo);

import confetti from "view_components/confetti/index.js";
application.register("confetti", confetti);

import intl_tel_input from "view_components/intl_tel_input/index.js";
application.register("intl-tel-input", intl_tel_input);

import recaptcha_v2 from "view_components/recaptcha_v2/index.js";
application.register("recaptcha-v2", recaptcha_v2);

import character_counter from "view_components/character_counter/index.js";
application.register("character-counter", character_counter);

import autosubmit_form_on_recaptcha from "view_components/autosubmit_form_on_recaptcha/index.js";
application.register("autosubmit-form-on-recaptcha", autosubmit_form_on_recaptcha);

import touchspin from "view_components/touchspin/index.js";
application.register("touchspin", touchspin);

import formvalidation_booking from "view_components/formvalidation/booking/index.js";
application.register("formvalidation--booking", formvalidation_booking);

import formvalidation_contact from "view_components/formvalidation/contact/index.js";
application.register("formvalidation--contact", formvalidation_contact);

import copyable_input from "view_components/copyable_input/index.js";
application.register("copyable-input", copyable_input);

import fit_text from "view_components/fit_text/index.js";
application.register("fit-text", fit_text);

import parallax_divider from "view_components/parallax_divider/index.js";
application.register("parallax-divider", parallax_divider);

import print_detect from "view_components/print_detect/index.js";
application.register("print-detect", print_detect);

import show_more from "view_components/show_more/index.js";
application.register("show-more", show_more);

// import geolocation_public from "../view_components/public/geolocation/index";
// application.register("public--geolocation", geolocation_public);

// //
// import swiper from "../view_components/swiper/index.js";
// application.register("swiper", swiper);

// import BootstrapModal from "../view_components/modal/bootstrap/index.js";
// application.register("modal--bootstrap", BootstrapModal);

// import colorPalletVisualizer from "../view_components/color_pallet_visualizer/index.js";
// application.register("color-pallet-visualizer", colorPalletVisualizer);

import textarea_autogrow from "stimulus-textarea-autogrow";
application.register("textarea-autogrow", textarea_autogrow);

import name_that_color from "view_components/name_that_color/index.js";
application.register("name-that-color", name_that_color);

import moving_letters from "view_components/moving_letters/index.js";
application.register("moving-letters", moving_letters);

// import scroll_to from "view_components/scroll_to/index";
// application.register("scroll-to", scroll_to);

import validation_fixes from "view_components/validation_fixes/index.js";
application.register("validation-fixes", validation_fixes);

import easepick from "view_components/easepick/index.js";
application.register("easepick", easepick);

// import header from "view_components/header/index.js";
// application.register("header", header);

// import bootstrap_modal from "view_components/modal/bootstrap/index.js";
// application.register("modal--bootstrap", bootstrap_modal);

import bootstrap_toast from "view_components/toast/bootstrap/index.js";
application.register("toast--bootstrap", bootstrap_toast);

// import popover from "view_components/popover/index.js";
// application.register("popover", popover);

import swiper from "view_components/swiper/index.js";
application.register("swiper", swiper);

// import development_tools from "view_components/development_tools/index.js";
// application.register("development-tools", development_tools);

// import analytics_google_initializer from "view_components/analytics/google/initializer/index.js";
// application.register("analytics--google--initializer", analytics_google_initializer);

// import analytics_google_event from "view_components/analytics/google/event/index.js";
// application.register("analytics--google--event", analytics_google_event);

// import analytics_initializer from "view_components/analytics/ahoy/initializer/index.js";
// application.register("analytics--initializer", analytics_initializer);

// import analytics_event from "view_components/analytics/ahoy/event/index.js";
// application.register("analytics", analytics_event);

import locale_informer from "view_components/locale_informer/index.js";
application.register("locale-informer", locale_informer);

// import privacy_cookie_policy from "view_components/privacy/cookie_policy/index.js";
// application.register("privacy--cookie-policy", privacy_cookie_policy);

// import privacy_content_consent from "view_components/privacy/content_consent/index.js";
// application.register("privacy--content-consent", privacy_content_consent);

// import privacy_cookie_iframe_manager from "view_components/privacy/cookie_iframe_manager/index.js";
// application.register("privacy--cookie-iframe-manager", privacy_cookie_iframe_manager);

// import privacy_asset_consent from "view_components/privacy/asset_consent/index.js";
// application.register("privacy--asset-consent", privacy_asset_consent);

// import privacy_cookie_policy_service_acceptor from "view_components/privacy/cookie_policy/service_acceptor/index.js";
// application.register("privacy--cookie-policy--service-acceptor", privacy_cookie_policy_service_acceptor);

// import widget from "view_components/widget/index.js";
// application.register("widget", widget);

// import espa_banner from "view_components/espa_banner/index.js";
// application.register("espa-banner", espa_banner);

// import visibility from "view_components/visibility/index.js";
// application.register("visibility", visibility);

// import content_animator from "view_components/content_animator/index.js";
// application.register("content-animator", content_animator);

import gallery from "view_components/gallery/index.js";
application.register("gallery", gallery);

import hero_gallery_bootstrap from "view_components/hero_gallery/bootstrap/index.js";
application.register("hero-gallery--bootstrap", hero_gallery_bootstrap);

import connectivity from "../view_components/connectivity/index.js";
application.register("connectivity", connectivity);

const setMetaTag = (nameOrProperty, content, isProperty = false) => {
  const selector = isProperty ? `meta[property='${nameOrProperty}']` : `meta[name='${nameOrProperty}']`;

  let tag = document.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    const attributeType = isProperty ? "property" : "name";
    tag.setAttribute(attributeType, nameOrProperty);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
};

//* Used on the page when turbo sets the events
function setMetadata(meta) { // eslint-disable-line jsdoc/require-jsdoc
  if (!meta) return;

  const { title, description, image, url } = meta;

  if (title) {
    document.title = title;
    setMetaTag("og:title", title, true);
  }

  if (description) {
    setMetaTag("description", description);
    setMetaTag("og:description", description, true);
  }

  if (image) {
    setMetaTag("og:image", image, true);
  }

  if (url) {
    setMetaTag("og:url", url, true);
  }
};

window.setMetadata = setMetadata;
